/**
 * Portal Header Component
 *
 * Professional header for the Conditions Portal with:
 * - Company logo (or text fallback)
 * - "CONDITIONS PORTAL" title
 * - Secure badge indicator
 */

import { Shield } from 'lucide-react';
import type { ConditionsPortalCompany } from '@/types/conditions-portal';

interface PortalHeaderProps {
  company: ConditionsPortalCompany | null;
}

export const PortalHeader = ({ company }: PortalHeaderProps) => {
  if (!company) {
    return (
      <div className="bg-white border-b">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <div className="flex items-center justify-center gap-4">
            <div className="flex items-center gap-1.5 px-2.5 py-1 bg-green-50 border border-green-200 rounded-full">
              <Shield className="h-3.5 w-3.5 text-green-600" />
              <span className="text-xs font-medium text-green-700">256-bit Encrypted</span>
            </div>

            <div className="h-8 w-px bg-gray-200" />

            <h1 className="text-lg font-semibold text-gray-900 tracking-tight">
              CONDITIONS PORTAL
            </h1>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white border-b">
      <div className="max-w-4xl mx-auto px-4 py-4">
        <div className="flex items-center justify-center gap-4">
          <div className="flex items-center gap-1.5 px-2.5 py-1 bg-green-50 border border-green-200 rounded-full">
            <Shield className="h-3.5 w-3.5 text-green-600" />
            <span className="text-xs font-medium text-green-700">256-bit Encrypted</span>
          </div>

          <div className="h-8 w-px bg-gray-200" />

          {company.logoUrl ? (
            <img
              src={company.logoUrl}
              alt={company.name}
              className="h-10 w-auto object-contain"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
              }}
            />
          ) : (
            <span className="text-lg font-semibold text-gray-900">
              {company.name}
            </span>
          )}

          <div className="h-8 w-px bg-gray-200" />

          <h1 className="text-lg font-semibold text-gray-900 tracking-tight">
            CONDITIONS PORTAL
          </h1>
        </div>
      </div>
    </div>
  );
};

export default PortalHeader;
